import { NativeElement2p8z5z0r9meck as NativeElement } from '../NativeElement.commonHtml.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ProgressBarClass;
function ProgressBar() {
  if (ProgressBarClass === VOID) {
    class $ extends NativeElement() {
      constructor(context) {
        super(context);
        this.native_1.tag_1 = 'progress';
        this.native_1.setAttribute_j9pxft_k$('aria-label', 'Progress');
      }
      set_ratio_1brdoa_k$(value) {
        // Inline function 'com.lightningkite.kiteui.views.valueDouble' call
        this.native_1.attributes_1.native_1.value = value;
      }
      get_ratio_ixudpe_k$() {
        // Inline function 'com.lightningkite.kiteui.views.valueDouble' call
        var tmp = this.native_1.attributes_1.native_1.value;
        var tmp0_safe_receiver = (!(tmp == null) ? typeof tmp === 'number' : false) ? tmp : null;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver;
        return tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs;
      }
    }
    initMetadataForClass($, 'ProgressBar');
    ProgressBarClass = $;
  }
  return ProgressBarClass;
}
//region block: exports
export {
  ProgressBar as ProgressBarl6xlv6j3g2vi,
};
//endregion

//# sourceMappingURL=ProgressBar.commonHtml.mjs.map
